import reducer from './reducers';
import * as videoSelectors from './selectors';
import * as videoTypes from './types';

export { videoSelectors, videoTypes };

export default reducer;
